const url =
  process.env.VUE_APP_TITLE === 'production'
    ? {
        invitationUrl: 'https://y.duoduolvxing.cn/shoutu/invitation/type_invitation_code',
        get_posterUrl: 'https://dog.duoduolvxing.cn/index/get_poster',
        mapUrl:
          'https://ddm.duoduolvxing.cn/ddlxfe/dog-map/index.html?isfullscreen=1&isstatusbar=1&touming=0&hidenavbar=1&hidestatusbar=2&forbidSlide=1&dogSpecialBg=1&h5loadfinish=1#/map-page',
        rename: 'https://dog.duoduolvxing.cn/info/rename', //改名接口
      }
    : {
        invitationUrl: 'http://test-y-dd.tt.cn/shoutu/invitation/type_invitation_code', //填写邀请码
        get_posterUrl: 'http://test-dog.duoduolvxing.cn/index/get_poster', //萌宠档案
        mapUrl:
          'https://ddm.duoduolvxing.cn/ddlxfe__test/dog-map/index.html?isfullscreen=1&isstatusbar=1&touming=0&hidenavbar=1&hidestatusbar=2&forbidSlide=1&dogSpecialBg=1&h5loadfinish=1#/map-page',
        rename: 'http://test-dog.duoduolvxing.cn/info/rename', //改名接口
      };
export default url;
